export default () => ({
  jobs: null,
  job: null,
  links: null,
  meta: null,
  hasData: false,
  error: '',
});
